import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ResultsDialog from './ResultsDialog';
import gameData, { GameShortNames } from '../gameData';
import FontKeys from '../FontKeys';

export default class GameHUD extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.returnBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-return', this).setInteractive()
      .setOrigin(0)
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.handleUiClick('replay');
      });

    const skipData = gameData.game === GameShortNames.tat || gameData.game === GameShortNames.tatJr ? { x: 21, y: 38, fontSize: 30, color: 0x000000 } : { x: 43, y: 59, fontSize: 28, color: 0xffffff };
    this.skipText = ABCyaPhaser.Text.addText(skipData.x, skipData.y, skipData.fontSize, skipData.color, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString('skip'), this).setVisible(false);
    ABCyaPhaser.Text.resizeFontToFitWidth(this.skipText, 70);

    this.menuBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-menu', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setInteractive()
      .setOrigin(0)
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
        this.handleUiClick('menu');
      });

    this.layoutRatio();
  }

  enableBtns() {
    this.returnBtn.setInteractive();
    this.menuBtn.setInteractive();
  }

  disableBtns() {
    this.returnBtn.disableInteractive();
    this.menuBtn.disableInteractive();
  }

  handleUiClick(e) {
    if (this.isResultsShowing) return;

    ABCyaPhaser.Audio.playOneShot('button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);

    let btn = e;
    if (btn === 'replay' && this.isSkipShowing) btn = 'skip';
    this.emit('UI_CLICK', btn);
  };

  showResults(levelData,isBest,newTime) {
    this.isResultsShowing = true;

    this.resultsDialog = new ResultsDialog(this.scene, levelData, isBest, newTime);
    this.resultsDialog.x = (this.scene.scale.width / 2) - (this.resultsDialog.bg.getBounds().width / 2);
    this.resultsDialog.y = -this.resultsDialog.bg.getBounds().height;
    this.resultsDialog.endY = this.scene.scale.height / 2;
    this.add(this.resultsDialog);

    ABCyaPhaser.Tweens.addTween(this.resultsDialog, 700, { y: this.resultsDialog.endY, easeParams: [1,0.3] }, Phaser.Math.Easing.Elastic.Out, () => {
      this.startResultsDialog();
    });
  };

  startResultsDialog() {
    this.resultsDialog.showDialog();
    this.resultsDialog.once('END_RESULTS_DIALOG', (next) => {this.finishShowResults(next);});
  };

  finishShowResults(e) {
    this.emit('RESULTS_DISMISSED', e);

    this.isResultsShowing = false;

    ABCyaPhaser.Tweens.addTween(this.resultsDialog, 700, { y: -(this.resultsDialog.bg.getBounds().height + 100) }, Phaser.Math.Easing.Back.In, () => {
      this.resultsDialog.destroy();
    });
  };

  toggleReturnSkip(btnString) {
    this.returnBtn.setFrame(`btn-${btnString}`);
    this.isSkipShowing = btnString === 'skip';

    if (btnString === 'skip') {
      this.skipText.setVisible(true);
    }
    else {
      this.skipText.setVisible(false);
    }

    this.enableBtns();
  };

  layoutRatio() {
    this.returnBtn.x = 10;
    this.returnBtn.y = 10;
    this.menuBtn.x = this.scene.scale.width - this.menuBtn.getBounds().width - 10;
    this.menuBtn.y = 10;
    this.skipText.setPosition(this.returnBtn.x + this.returnBtn.width / 2 + 1, this.returnBtn.y + this.returnBtn.height / 2);

    if (this.resultsDialog) {
      this.resultsDialog.x = (this.scene.scale.width / 2) - (this.resultsDialog.bg.getBounds().width / 2);
      this.resultsDialog.y = (this.scene.scale.height / 2) - (this.resultsDialog.bg.getBounds().height / 2);
    }
  };
}